import { isAccess } from '@module-role/utils';
import { takeUntil, map, take } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnDestroy
} from '@angular/core';
import { RoleTypeData } from '@module-role/interfaces/role-type-data.interface';
import { CurrentUserService } from '@services/current-user/current-user.service';

@Component({
  selector: 'app-link-or-text',
  templateUrl: './link-or-text.component.html',
  styleUrls: ['./link-or-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LinkOrTextComponent implements OnDestroy {
  destroy$ = new Subject();
  hasAccess$!: Observable<boolean>;
  @Input() url!: string;
  @Input() text!: string;
  @Input() isExternal = false;
  @Input() set roleData(data: RoleTypeData) {
    this.hasAccess$ = this._currentUser.currentUser$.pipe(
      takeUntil(this.destroy$),
      take(1),
      map((user) => {
        return isAccess(user, data);
      })
    );
  }
  constructor(private _currentUser: CurrentUserService) {}
  ngOnDestroy(): void {
    this.destroy$.next(null);
  }
}
